import { useUiMessageContext } from "../components/UIMessages/context";
import { WARN } from "../components/UIMessages";
import ErrorCodes from "../config/ErrorCodes";
import { Site } from "../config/sites";
import { siteUrl } from "../utils/SiteUtils";
import { useBjelinTranslations } from "./TranslationHooks";
import { useCallback } from "react";

export function useUserWrongSiteMessage() {
  const { displayMessage } = useUiMessageContext();
  const t = useBjelinTranslations();
  const showUserWrongSiteMessage = useCallback(
    (userSite: Site) => {
      const code = ErrorCodes.USER_WRONG_SITE;
      displayMessage({
        buttons: [
          {
            text: t(code + ".button"),
            type: "primary",
            url: siteUrl(userSite)
          }
        ],
        code,
        persist: true,
        text: t(code),
        type: WARN
      });
    },
    [t, displayMessage]
  );

  return {
    showUserWrongSiteMessage
  };
}
